import React from 'react'
import { Text, Tip } from 'grommet'
import { isMobile } from 'react-device-detect'

const TipDrop = ({
  content,
  position,
  children,
  inline = false,
  disabled = false,
}) => {
  let alignPos = {}

  switch (position) {
    case 'top':
      alignPos = { bottom: 'top' }
      break
    case 'right':
      alignPos = { left: 'right' }
      break
    case 'bottom':
      alignPos = { top: 'bottom' }
      break
    case 'left':
      alignPos = { right: 'left' }
      break
    default:
      alignPos = { bottom: 'top' }
      break
  }
  if (isMobile || disabled) return children
  return (
    <Tip
      content={
        <Text size="1.4rem" color="white" textAlign="center">
          {content}
        </Text>
      }
      dropProps={{ align: alignPos, stretch: false, inline: inline }}
    >
      {children}
    </Tip>
  )
}

export default TipDrop
